import React from 'react';
import { Checkbox as AntdCheckbox, CheckboxProps } from 'antd';
import { CheckboxGroupProps } from 'antd/lib/checkbox';
import './checkbox.scss';

interface Props extends CheckboxProps {}

const Checkbox = (props: Props) => {
	const { children, className, ...otherProps } = props;
	return (
		<AntdCheckbox className={`bringg-checkbox ${className || ''}`} {...otherProps}>
			{children}
		</AntdCheckbox>
	);
};

Checkbox.Group = (props: CheckboxGroupProps) => {
	return <AntdCheckbox.Group {...props} />;
};

export default Checkbox;
